import DisclosureTypes from './DisclosureTypes';

const initialState = {
  disclosureTop: {},
  sectionDetail: [],
  tableHeading: [],
  patientGroupTop: {},
  searchResult: null,
  total: 0,
  totalPages: 1,
  queries: {
    page: 1,
    size: 10,
    year: 0,
    keyWords: '',
    sectionId: 0,
    domain: ''
  }
};

export default function disclosureReducer (state = initialState, action) {
  const {
    type,
    payload
  } = action;
  let newState = { ...state };
  switch (type) {
    case DisclosureTypes.GET_DISCLOSURE_TOP_SUCCESS:
      newState.disclosureTop = { ...payload };
      return newState;
    case DisclosureTypes.GET_SECTION_DETAIL_SUCCESS:
    {
      newState.sectionDetail = [...payload.content];
      newState.total = payload.totalElements;
      newState.queries.size = payload.pageSize;
      newState.totalPages = Math.ceil(payload.totalElements / newState.queries.size);
      return newState;
    }
    case DisclosureTypes.GET_SECTION_TABLE_HEADING_SUCCESS:
      newState.tableHeading = [...payload];
      return newState;
    case DisclosureTypes.GET_PATIENT_GROUP_TOP_SUCCESS:
      newState.patientGroupTop = { ...payload };
      return newState;
    case DisclosureTypes.DO_SEARCH_SUCCESS:
      newState.searchResult = [...payload];
      return newState;
    case DisclosureTypes.UPDATE_QUERIES:
      newState.queries.year = payload.year;
      newState.queries.sectionId = payload.sectionId;
      newState.queries.domain = payload.domain;
      return newState;
    default:
      newState = state;
      break;
  }

  // return new state
  return newState;
}
